import { EvaluatorEvaluation, EvaluatorRequest } from "../evaluation/evalautor/Evaluator"
import UserEvent from "./UserEvent"
import { Properties } from "../model/model"
import ExperimentEvaluation from "../evaluation/evalautor/experiment/ExperimentEvaluation"
import RemoteConfigEvaluation from "../evaluation/evalautor/remoteconfig/RemoteConfigEvaluation"
import { Clock } from "../util/TimeUtil"
import { InAppMessageEvaluation } from "../evaluation/evalautor/iam/InAppMessageEvaluation"

export default class UserEventFactory {
  private static ROOT_TYPE = "$targetingRootType"
  private static ROOT_ID = "$targetingRootId"
  private static CONFIG_ID_PROPERTY_KEY = "$parameterConfigurationId"
  private static EXPERIMENT_VERSION_KEY = "$experiment_version"
  private static EXECUTION_VERSION_KEY = "$execution_version"

  private readonly clock: Clock

  constructor(clock: Clock) {
    this.clock = clock
  }

  create(request: EvaluatorRequest, evaluation: EvaluatorEvaluation): UserEvent[] {
    const timestamp = this.clock.currentMillis()
    const events = new Array<UserEvent>()

    const rootEvent = this.createEvent(request, evaluation, timestamp, {})
    if (rootEvent) {
      events.push(rootEvent)
    }

    evaluation.targetEvaluations.forEach((targetEvaluation) => {
      const properties: Properties = {
        [UserEventFactory.ROOT_TYPE]: request.key.type,
        [UserEventFactory.ROOT_ID]: request.key.id
      }
      const targetEvent = this.createEvent(request, targetEvaluation, timestamp, properties)
      if (targetEvent) {
        events.push(targetEvent)
      }
    })

    return events
  }

  private createEvent(
    request: EvaluatorRequest,
    evaluation: EvaluatorEvaluation,
    timestamp: number,
    properties: Properties
  ): UserEvent | null {
    if (evaluation instanceof ExperimentEvaluation) {
      properties[UserEventFactory.CONFIG_ID_PROPERTY_KEY] = evaluation.config?.id
      properties[UserEventFactory.EXPERIMENT_VERSION_KEY] = evaluation.experiment.version
      properties[UserEventFactory.EXECUTION_VERSION_KEY] = evaluation.experiment.executionVersion
      return UserEvent.exposure(request.user, evaluation, properties, timestamp)
    }

    if (evaluation instanceof RemoteConfigEvaluation) {
      return UserEvent.remoteConfig(
        request.user,
        evaluation,
        {
          ...properties,
          ...evaluation.properties
        },
        timestamp
      )
    }

    if (evaluation instanceof InAppMessageEvaluation) {
      return null
    }

    throw new Error(`Unsupported Evaluation [${typeof evaluation}]`)
  }
}
